import { Storage } from "../../lib/data/Storage.js";

export class AppStorage extends Storage {

    // ------------------------------------------------------------------------

    static ALL_EMPLOYEES = 'allEmployees';

    async loadAllEmployees (datamodel, query) { return this.loadModelData(AppStorage.ALL_EMPLOYEES, datamodel, query); };
    getAllEmployees () { return this.getData(AppStorage.ALL_EMPLOYEES); };

    // ------------------------------------------------------------------------

    static ALL_CUSTOMERS = 'allCustomers';

    async loadAllCustomers (datamodel, query) { return this.loadModelData(AppStorage.ALL_CUSTOMERS, datamodel, query); };
    getAllCustomers () { return this.getData(AppStorage.ALL_CUSTOMERS); };

    // ------------------------------------------------------------------------

    static ALL_MACHINES = 'allMachines';

    async loadAllMachines (datamodel, query) { return this.loadModelData(AppStorage.ALL_MACHINES, datamodel, query); };
    getAllMachines () { return this.getData(AppStorage.ALL_MACHINES); };

    // ------------------------------------------------------------------------

    static ALL_WORK_ACTIVITIES = 'allWorkActivities';

    async loadAllWorkActivities (datamodel, query) { return this.loadModelData(AppStorage.ALL_WORK_ACTIVITIES, datamodel, query); };
    getAllWorkActivities () { return this.getData(AppStorage.ALL_WORK_ACTIVITIES); };

    // ------------------------------------------------------------------------

    static ALL_WORK_TYPES = 'allWorkTypes';

    async loadAllWorkTypes (datamodel, query) { return this.loadModelData(AppStorage.ALL_WORK_TYPES, datamodel, query); };
    getAllWorkTypes () { return this.getData(AppStorage.ALL_WORK_TYPES); };

    // ------------------------------------------------------------------------

    static ALL_WORK_ACTIVITY_ACTIONS = 'allWorkActivityActions';

    async loadAllWorkActivityActions  (datamodel, query) { return this.loadModelData(AppStorage.ALL_WORK_ACTIVITY_ACTIONS, datamodel, query); };
    getAllWorkActivityActions  () { return this.getData(AppStorage.ALL_WORK_ACTIVITY_ACTIONS); };

    // ------------------------------------------------------------------------

    static ALL_WORK_HOLIDAYS = 'allWorkHolidays';

    async loadAllWorkHolidays  (datamodel, query) { return this.loadModelData(AppStorage.ALL_WORK_HOLIDAYS, datamodel, query); };
    getAllWorkHolidays  () { return this.getData(AppStorage.ALL_WORK_HOLIDAYS); };

    // ------------------------------------------------------------------------

}